<template>
  <Layout>
    <div class="row mb-3">
      <div class="col-2 mt-2">
        <button type="button" onclick="history.back()" class="btn btn-sm btn-outline-dark">
          <i class="bx bx-chevron-left"></i>
          Back
        </button>
      </div>

      <div class="col-5 text-end mt-2">
        <h4>Resolve Accident</h4>
      </div>

      <div class="col-5 text-end">
        <button class="btn btn-sm btn-outline-success m-2" @click="showResolveConfirmation()"
          v-show="selectedAccident.status === 'Open'">
          <i class="mdi mdi-check"></i> Mark as Resolved
        </button>
        <button class="btn btn-sm btn-outline-primary m-2" disabled>
          Status: {{ selectedAccident.status }}
        </button>
      </div>
    </div>
    <div class="row">
      <div>
        <div class="card">
          <div class="card-body row">
            <div class="row">
              <div class="col-6">
                <h4 class="card-title">Accident Details</h4>
              </div>
              <div class="col-6 text-end">
                <div v-if="disabled">
                  <button class="btn btn-primary btn-sm mb-2" @click="editAccident">
                    Edit Accident
                  </button>
                </div>

                <div v-else>
                  <button class="btn btn-success btn-sm mb-2 mx-2" @click="updateAccident">
                    Update Accident
                  </button>

                  <button class="btn btn-danger btn-sm mb-2" @click="function () {
                    disabled = true;
                  }
                    ">
                    Cancel
                  </button>
                </div>
              </div>
            </div>
            <hr />
            <div class="table-responsive col-6">
              <table class="table mb-0">
                <tbody>
                  <tr>
                    <th scope="row">Accident Id</th>
                    <td>
                      <input type="text" class="form-control inp-bg" v-model="selectedAccident.id" disabled />
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Source</th>
                    <td>
                      <input type="text" class="form-control inp-bg" v-model="selectedAccident.source_name" disabled />
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Chainage Number</th>
                    <td>
                      <input type="text" class="form-control inp-bg" v-model="selectedAccident.ch_no"
                        placeholder="Enter chainage number" :disabled="disabled" />
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Hydra Time</th>
                    <td>
                      <input type="time" class="form-control inp-bg" v-model="selectedAccident.hydra_time"
                        :disabled="disabled" />
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Side</th>
                    <td>
                      <v-select v-model="selectedAccident.side" class="style-chooser" :options="['LHS', 'RHS']"
                        :disabled="disabled"></v-select>
                    </td>
                  </tr>
                  <tr v-show="selectedAccident.status !== 'Open'">
                    <th scope="row">Close Date/Time</th>
                    <td>
                      <input type="text" class="form-control inp-bg" v-model="selectedAccident.close_datetime" />
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Assigned To</th>
                    <td>
                      <v-select class="style-chooser" v-model="selectedAccident.reported_to_name"
                        :options="options.informedTo" label="firstName" :reduce="(vc) => vc.firstName"
                        disabled></v-select>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Accident Date/Time</th>
                    <td>
                      {{
                        new Date(
                          selectedAccident.incident_datetime
                        ).toLocaleString()
                      }}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Reported Date/Time</th>
                    <td>
                      {{
                        new Date(
                          selectedAccident.reported_datetime
                        ).toLocaleString()
                      }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="table-responsive col-6">
              <table class="table mb-0">
                <tbody>
                  <tr>
                    <th scope="row">Nature of Accident</th>
                    <td>
                      <input type="text" class="form-control inp-bg" v-model="selectedAccident.nature_of_accident"
                        placeholder="Enter nature of accident" :disabled="disabled" />
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Reason of Accident</th>
                    <td>
                      <input type="text" class="form-control inp-bg" v-model="selectedAccident.reason_of_accident"
                        placeholder="Enter reason of accident" :disabled="disabled" />
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Nature of Injury</th>

                    <td>
                      <input type="text" class="form-control inp-bg" v-model="selectedAccident.nature_of_injury"
                        placeholder="Enter nature of injury" :disabled="disabled" />
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Name of Police Station</th>
                    <td>
                      <input type="text" class="form-control inp-bg" v-model="selectedAccident.police_station"
                        placeholder="Enter police station name" :disabled="disabled" />
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Name of Hospital</th>

                    <td>
                      <input type="text" class="form-control inp-bg" v-model="selectedAccident.hospital_name"
                        placeholder="Enter hospital name" :disabled="disabled" />
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">MBCB</th>

                    <td>
                      <input type="text" class="form-control inp-bg" v-model="selectedAccident.mbcb"
                        placeholder="Enter MBCB" :disabled="disabled" />
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Description</th>
                    <td>
                      <input type="text" class="form-control inp-bg" v-model="selectedAccident.description"
                        placeholder="Enter description" :disabled="disabled" />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Incident Vehicle Details -->
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body row">
            <h4 class="card-title col-6">Vehicle Details</h4>
            <div class="col-6 text-end">
              <button @click="addVehicle()" class="btn btn-primary btn-sm mb-3">
                Add Vehicle
              </button>
            </div>
            <hr />
          </div>
          <div class="row">
            <div class="col-12">
              <div v-if="items.length > 0" class="mb-3">
                <b-table-lite :items="items" :fields="fields">
                  <template #cell(actions)="row">
                    <b-button size="sm" variant="primary" class="m-1" @click="viewVehicleDetails(row.item)">View
                    </b-button>
                    <b-button size="sm" variant="warning" class="m-1" @click="editVehicleDetails(row.item)">Edit
                    </b-button>
                    <b-button size="sm" variant="danger" class="m-1" @click="deleteVehicleDetails(row.item.id)">Delete
                    </b-button>
                  </template>
                </b-table-lite>
              </div>
              <div v-else class="text-center">
                <p>Vehicle information not added</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body row">
            <h4 class="card-title col-6">Accident Photos</h4>
            <div class="col-6 text-end">
              <button @click="" class="btn btn-primary btn-sm mb-3">
                Add New Photos
              </button>
            </div>
            <hr />
          </div>


          <div v-if="incidentImages.length > 0">
            <img v-for="(src, index) in incidentImages" :key="index" class="float-left image"
              @click="() => showCaptiomImg(index)" width="150" :src="src" style="margin-right: 10px; cursor: pointer" />
          </div>
          <div v-else class="text-center">
            <p>Images not uploaded</p>
          </div>

          <vue-easy-lightbox :visible="visibleCaption" :imgs="incidentImages" :index="index"
            @hide="handleCaptionHide"></vue-easy-lightbox>
        </div>
      </div>
    </div>

    <!-- Select RPO modal -->
    <b-modal id="select-rpo-modal" size="md" hide-footer>
      <template #modal-header>
        <div>
          <h5>Select RPO</h5>
        </div>
        <div class="m-2">
          <button class="btn btn-sm btn-success" @click="informedToRpo()">
            Select
          </button>
          <button class="btn btn-sm btn-outline-danger m-2" @click="$bvModal.hide('select-rpo-modal')">
            Cancel
          </button>
        </div>
      </template>
      <div>
        <v-select v-model="selectedAccident.reported_to_name" :options="options.informedTo" label="firstName"
          :reduce="(vc) => vc.firstName"></v-select>
      </div>
    </b-modal>

    <!-- Resolve modal -->
    <b-modal id="comment-resolve-modal" title="Resolve Confirmation" title-class="font-18" hide-footer centered>
      <div class="card">
        <div class="card-body p-2">
          <form @submit.prevent="markAsResolved">
            <div class="row">
              <div class="col-12">
                <h4>ACCIDENT ID: #{{ selectedAccident.id }}</h4>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <h6>Are you sure you want to mark the incident as resolved?</h6>

                <hr />

                <h6>Important Notes</h6>
                <ul>
                  <li>
                    <small>You cannot reopen the resolved incident again.</small>
                  </li>
                  <li>
                    <small>Associated RPO will be notified once the incident is
                      marked as resolved.</small>
                  </li>
                </ul>
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-12 text-center">
                <button type="submit" class="btn btn-success btn-block">
                  <i class="fas fa-check"></i> Confirm & Resolve Incident
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </b-modal>

    <!-- view vehicle details -->
    <b-modal id="view-vehicle-details-modal" title="Edit Vehicle Details" title-class="font-18" hide-footer
      no-close-on-backdrop>
      <template #modal-header>
        <div>
          <h5>Vehicle Details</h5>
        </div>
        <div>
          <button class="btn btn-sm btn-outline-danger" @click="$bvModal.hide('view-vehicle-details-modal')">
            Cancel
          </button>
        </div>
      </template>

      <div>
        <div class="card">
          <div class="card-body">
            <div class="table-responsive">
              <table class="table mb-0">
                <tbody>
                  <tr>
                    <th scope="row">Driver Name</th>
                    <td>{{ selectedVehicle.driver_name }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Vehicle No.</th>
                    <td>{{ selectedVehicle.vehicle_no }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Vehicle Class</th>
                    <td>{{ vehicleClass }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Mobile No.</th>
                    <td>{{ selectedVehicle.mobile_no }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Driver Address</th>
                    <td>{{ selectedVehicle.driver_address }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Origin of Vehicle</th>
                    <td>{{ selectedVehicle.origin }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Point of Arrival</th>
                    <td>{{ selectedVehicle.arrival }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Destination of Vehicle</th>
                    <td>{{ selectedVehicle.destination }}</td>
                  </tr>
                  <tr>
                    <th scope="row">No. of Passengers</th>
                    <td>
                      {{ selectedVehicle.passenger_count }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- Edit vehicle details -->
    <b-modal id="edit-vehicle-details-modal" title="Edit Vehicle Details" title-class="font-18" hide-footer
      no-close-on-backdrop>
      <template #modal-header>
        <div>
          <h5>Edit Accident Vehicle</h5>
        </div>
        <div>
          <button class="btn btn-sm btn-outline-danger" @click="$bvModal.hide('edit-vehicle-details-modal')">
            Cancel
          </button>
        </div>
      </template>
      <div class="card">
        <div class="card-body p-2">
          <div class="mb-3">
            <label>Driver Name</label>
            <input class="form-control inp-bg" v-model="selectedVehicle.driver_name" placeholder="Enter driver name"
              required />
          </div>
          <div class="mb-3">
            <label>Vehicle No.</label>
            <input class="form-control inp-bg" v-model="selectedVehicle.vehicle_no" placeholder="Enter vehicle number"
              required />
          </div>
          <div class="mb-3">
            <label>Vehicle Class</label>
            <v-select class="form-control" v-model="vehicleClass" :options="options.vehicleClass" label="class_name"
              :reduce="(category) => category.class_name"></v-select>
          </div>
          <div class="mb-3">
            <label>Mobile No.</label>
            <input class="form-control inp-bg" v-model="selectedVehicle.mobile_no" placeholder="Enter mobile number"
              required />
          </div>
          <div class="mb-3">
            <label>Driver Address</label>
            <input class="form-control inp-bg" v-model="selectedVehicle.driver_address"
              placeholder="Enter driver address" required />
          </div>
          <div class="mb-3">
            <label>Origin of Vehicle</label>
            <input class="form-control inp-bg" v-model="selectedVehicle.origin" placeholder="Enter origin of Vehicle"
              required />
          </div>
          <div class="mb-3">
            <label>Point of Arrival</label>
            <input class="form-control inp-bg" v-model="selectedVehicle.arrival" placeholder="Enter point of arrival"
              required />
          </div>
          <div class="mb-3">
            <label>Destination of Vehicle</label>
            <input class="form-control inp-bg" v-model="selectedVehicle.destination"
              placeholder="Enter destination of vehicle" required />
          </div>
          <div class="mb-3">
            <label>No. of Passengers</label>
            <input class="form-control inp-bg" type="number" v-model="selectedVehicle.passenger_count"
              placeholder="Enter destination of vehicle" required />
          </div>
          <hr />
          <div class="row">
            <div class="col-12 text-center">
              <button type="submit" class="btn btn-success btn-block">
                <i class="fas fa-check"></i> Edit Vehicle Details
              </button>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- add vehicle details modal -->
    <b-modal id="add-vehicle-details-modal" title="Add Vehicle Details" title-class="font-18" hide-footer
      no-close-on-backdrop size="xl">
      <template #modal-header>
        <div>
          <h5>Add Accident Vehicle</h5>
        </div>
        <div>
          <button class="btn btn-sm btn-outline-danger" @click="$bvModal.hide('add-vehicle-details-modal')">
            Cancel
          </button>
        </div>
      </template>
      <div class="card">
        <div class="card-body p-2">
          <div class="row">
            <div class="col-6">
              <div class="mb-3">
                <label>Driver Name</label>
                <input class="form-control inp-bg" v-model="addVehicleDetailsObj.driverName"
                  placeholder="Enter driver name" required />
              </div>
              <div class="mb-3">
                <label>Vehicle No.</label>
                <input class="form-control inp-bg" v-model="addVehicleDetailsObj.vehicleNumber"
                  placeholder="Enter vehicle number" style="text-transform: uppercase" required />
              </div>
              <div class="mb-3">
                <label>Vehicle Class</label>
                <v-select class="form-control" v-model="addVehicleDetailsObj.vehicleClass"
                  :options="options.vehicleClass" label="class_name" :reduce="(category) => category.id"></v-select>
              </div>
              <div class="mb-3">
                <label>Mobile No.</label>
                <input class="form-control inp-bg" v-model="addVehicleDetailsObj.mobileNumber"
                  placeholder="Enter mobile number" />
              </div>
              <div class="mb-3">
                <label>Driver Address</label>
                <input class="form-control inp-bg" v-model="addVehicleDetailsObj.driverAddress"
                  placeholder="Enter driver address" required />
              </div>


            </div>
            <div class="col-6">
              <div class="mb-3">
                <label>Origin of Vehicle</label>
                <input class="form-control inp-bg" v-model="addVehicleDetailsObj.originAddress"
                  placeholder="Enter origin of Vehicle" required />
              </div>
              <div class="mb-3">
                <label>Point of Arrival</label>
                <input class="form-control inp-bg" v-model="addVehicleDetailsObj.arrivalPoint"
                  placeholder="Enter point of arrival" required />
              </div>
              <div class="mb-3">
                <label>Destination of Vehicle</label>
                <input class="form-control inp-bg" v-model="addVehicleDetailsObj.destination"
                  placeholder="Enter destination of vehicle" required />
              </div>
              <div class="mb-3">
                <label>No. of Passengers</label>
                <input class="form-control inp-bg" type="number" v-model="addVehicleDetailsObj.passengers"
                  placeholder="Enter destination of vehicle" required />
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr />
      <div class="row">
        <div class="col-12 text-center">
          <button type="submit" class="btn btn-success btn-block">
            <i class="fas fa-check"></i> Add Vehicle Details
          </button>
        </div>
      </div>



    </b-modal>
  </Layout>
</template>

<script>
import Layout from "@/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Swal from "sweetalert2";
import incidentMixin from "../../mixins/incident";
import VueEasyLightbox from "vue-easy-lightbox";

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Incident Details",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },

  mixins: [incidentMixin],
  props: {
    accidentId: String,
  },

  components: {
    Layout,
    PageHeader,
    VueEasyLightbox,
  },

  data() {
    return {
      selectedAccident: {},
      addVehicleDetailsObj: {},
      visibleCaption: false,
      index: 1,
      vehicleClass: null,
      vehicleNumber: null,
      selectedVehicle: {},
      disabled: true,
      items: [],
      fields: [
        {
          key: "driver_name",
          label: "Driver Name",
          sortable: true,
        },
        {
          key: "vehicle_no",
          label: "Vehicle No.",
          sortable: false,
        },
        {
          key: "mobile_no",
          label: "Mobile No.",
          sortable: false,
        },
        {
          key: "passenger_count",
          label: "No. of Passengers",
          sortable: false,
        },
        {
          key: "driver_address",
          label: "Driver Address",
          sortable: false,
        },
        {
          key: "actions",
        },
      ],

      options: {
        vehicleClass: [],
        offenceId: [],
        districtCode: [],
        stateCode: [],
        side: ["LHS", "RHS"],
        subCategory: [],
        informedTo: [],
        accidentLevel: [],
      },
    };
  },

  methods: {
    async onInput(e) {
      this.vehicleNumber = await e.target.innerText;
    },

    viewVehicleDetails(vehicle) {
      this.selectedVehicle = vehicle;
      if (this.selectedVehicle.vehicle_class_id) {
        const vehicleClass = this.options.vehicleClass.find(
          (vehicleClass) =>
            vehicleClass.id === this.selectedVehicle.vehicle_class_id
        );
        this.vehicleClass = vehicleClass.class_name;
      }
      this.$bvModal.show("view-vehicle-details-modal");
    },

    editVehicleDetails(vehicle) {
      this.selectedVehicle = vehicle;
      const vehicleClass = this.options.vehicleClass.find(
        (vehicleClass) =>
          vehicleClass.id === this.selectedVehicle.vehicle_class_id
      );
      this.vehicleClass = vehicleClass.class_name;
      this.$bvModal.show("edit-vehicle-details-modal");
    },

    deleteVehicleDetails(id) {
      try {
        const body = {
          id: id,
        };
        Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes",
        }).then(async (result) => {
          if (result.isConfirmed) {
            Swal.fire("Deleted!", "Your file has been deleted.", "success");
            await this.DeleteVehicleDetails(body);
            await this.showVehicles(this.selectedAccident.id);
          }
        });
      } catch (e) {
        Swal.fire("Failed!", "Failed to delete vehicle", "error");
      }
    },

    async submitEditVehicleDetails() {
      try {
        this.selectedVehicle.vehicleClass =
          this.selectedAccident.vehicle_class_id;
        this.EditVehicleDetails(this.selectedVehicle);
        Swal.fire(
          "Updated!",
          "Vehicle details updated successfully",
          "success"
        ).then(async () => {
          this.$bvModal.hide("edit-vehicle-details-modal");
          this.addVehicleDetailsObj = {};
          await this.showVehicles(this.selectedAccident.id);
        });
      } catch (e) {
        Swal.fire("Failed!", "Failed to update vehicle details", "error");
      }
    },

    async showVehicles(id) {
      const body = {
        id: id,
      };
      this.items = await this.ShowVehicleDetails(body);

      if (
        this.vehicleClass === null &&
        this.items[0].vehicle_class_id !== null
      ) {
        const vehicleClass = this.options.vehicleClass.find(
          (vehicleClass) => vehicleClass.id === this.items[0].vehicle_class_id
        );
        this.vehicleClass = vehicleClass.class_name;
      }

      // if (this.vehicleNumber === null)
      //   this.vehicleNumber = this.items[0].vehicle_no;
    },

    sendNotificationToRPO() {
      this.$bvModal.show("select-rpo-modal");
    },

    showResolveConfirmation() {
      this.$bvModal.show("comment-resolve-modal");
    },

    async markAsResolved() {
      try {
        this.$store.dispatch("layout/changeLoaderValue", true);
        const body = {
          id: this.selectedAccident.id,
          status: "Resolved",
          close_datetime: new Date().toISOString(),
        };
        this.UpdateAccident(body);

        this.$store.dispatch("layout/changeLoaderValue", false);
        Swal.fire(
          "Accident Resolved",
          "Accident has been resolved and notifications have been sent out to respective teams",
          "success"
        ).then(() => {
          this.$bvModal.hide("comment-resolve-modal");
          this.$router.push("/incident/accidents");
        });
      } catch (e) {
        console.log(e);
        Swal.fire(
          "Operation Failed",
          "Failed to resolve the accident due to some technical issue.",
          "error"
        );
      }
    },

    async getIncidentMasters() {
      try {
        const incidents = await this.GetIncidentMasters();
        this.options.vehicleClass = incidents.getVehicleClass;
        this.options.offenceId = incidents.getOffenceId;
        this.options.districtCode = incidents.getDistrictCode;
        this.options.stateCode = incidents.getStateCode;
        this.options.subCategory = incidents.getIncidentSubCategory;
        this.options.informedTo = incidents.rpoData;
        this.options.accidentLevel = incidents.getAccidentLevel;
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        Swal.fire(
          "Network Error",
          "Failed to fetch data from the server. Please check your internet connection.",
          "error"
        );
      }
    },

    showCaptiomImg(index) {
      this.index = index;
      this.visibleCaption = true;
    },

    handleCaptionHide() {
      this.visibleCaption = false;
    },

    getReadableDateTime(dateTime) {
      if (dateTime) {
        // const date = String(dateTime).split("T");
        return `${new Date(dateTime).toLocaleString()}`;
      }
    },

    editAccident() {
      Swal.fire({
        title: "Are you sure?",
        text: "want to edit this accident!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.disabled = false;
        }
      });
    },

    updateAccident() {
      try {
        Swal.fire({
          title: "Are you sure?",
          text: "want to update this accident!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes",
        }).then(async (result) => {
          if (result.isConfirmed) {
            this.UpdateAccident(this.selectedAccident);
            this.disabled = true;
          }
        });
      } catch (error) {
        Swal.fire("Failed!", error, "error");
      }
    },

    addVehicle() {
      this.$bvModal.show("add-vehicle-details-modal");
    },

    async submitVehicleDetails() {
      try {
        this.addVehicleDetailsObj.incident_id = this.selectedAccident.id;
        this.AddVehicleDetails(this.addVehicleDetailsObj);
        Swal.fire(
          "Saved!",
          "Vehicle details saved successfully",
          "success"
        ).then(async () => {
          this.$bvModal.hide("add-vehicle-details-modal");
          this.addVehicleDetailsObj = {};
          await this.showVehicles(this.selectedAccident.id);
        });
      } catch (e) {
        Swal.fire("Failed!", e, "error");
      }
    },
  },

  computed: {
    incidentImages() {
      return this.selectedAccident.images
        ? this.selectedAccident.images.map((e) => e.media_url)
        : [];
    },
  },

  async mounted() {
    await this.getIncidentMasters();
  },

  async created() {
    this.selectedAccident = await this.AccidentDetailsById(this.accidentId);
    this.showVehicles(this.selectedAccident.id);
    this.vehicleNumber = this.selectedAccident.vehicle_no;
    this.vehicleClass = this.selectedAccident.class_name;
  },
};
</script>
<style scoped>
.custom-modal {
  width: 750px;
  height: 400px;
}
</style>
